import firebase from "services/FirebaseService";
import { dispatch } from "whiteboard/AppStore";
import find from "lodash/find";
import reject from "lodash/reject";
import get from "lodash/get";

const db = firebase.firestore();

let newsRecent_unsubscribe;

const defaultState = {
  newsRecent: []
};

const model = {
  state: defaultState,
  reducers: {
    addItem(state, { id, data, prop }) {
      const prev = find(state[prop], { id });
      if (prev) {
        return state;
      }
      let items = state[prop].slice();
      items.push({ id, ...data });
      return { ...state, [prop]: items };
    },
    updateItem(state, { id, data, prop }) {
      let items = state[prop].map(item => {
        if (item.id === id) {
          return { id, ...data };
        }
        return item;
      });
      return { ...state, [prop]: items };
    },
    removeItem(state, { id, data, prop }) {
      let items = reject(state[prop], item => {
        return item.id === id;
      });
      return { ...state, [prop]: items };
    }
  },
  effects: {
    async init(payload, rootState) {
      dispatch.news.getNewsRecent({});
    },

    async saveNewsArticle(article, rootState) {
      const articleRef = db.collection("news").doc(article.id);
      await articleRef.update(article);
    },

    async createNewsArticle(article, rootState) {
      await db.collection("news").add({
        createdAt: new Date(),
        body: "empty",
        title: "title",
        image: "",
        isPublic: false
      });
    },

    async getNewsRecent({}, rootState) {
      const prop = "newsRecent";
      if (newsRecent_unsubscribe) {
        newsRecent_unsubscribe();
        newsRecent_unsubscribe = undefined;
      }

      let newsRecent = await db.collection("news");

      if (!rootState.auth.profile.isAdmin) {
        newsRecent = newsRecent.where("isPublic", "==", true);
      }
      newsRecent = newsRecent
        .where("createdAt", "<=", new Date())
        .orderBy("createdAt", "desc")
        .limit(10);

      newsRecent_unsubscribe = newsRecent.onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          if (change.type === "added") {
            this.addItem({ id: change.doc.id, data: change.doc.data(), prop });
          } else if (change.type === "modified") {
            this.updateItem({ id: change.doc.id, data: change.doc.data(), prop });
          } else if (change.type === "removed") {
            this.removeItem({ id: change.doc.id, data: change.doc.data(), prop });
          }
        });
      });
    }
  }
};

export default model;



// WEBPACK FOOTER //
// ./src/whiteboard/models/news.js